import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { forceResize } from '@mode/shared/util-js';
import { MatLegacyMenuTrigger } from '@angular/material/legacy-menu';
import { trackByFactory } from '@mode/capra';
import { FormatListItem } from '../format-list-item';

@Component({
  selector: 'mode-format-builder-field-selector',
  templateUrl: './field-selector.component.html',
  styleUrls: ['./field-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldSelectorComponent implements OnChanges, AfterViewInit {
  @ViewChild('fieldsMenuTrigger') fieldsMenuTrigger!: MatLegacyMenuTrigger;
  @Input() emitOnUnset = true;
  @Input() fields: Array<FormatListItem> = [];
  @Input() selectedFieldToFormat: string | null = null;
  @Output() fieldSelected = new EventEmitter<FormatListItem>();
  selectedField: FormatListItem | undefined;
  fieldTrackByFn = trackByFactory<FormatListItem>(({ formatKey }) => formatKey);

  selectField(field?: FormatListItem) {
    this.selectedField = field;
    if (field != null || this.emitOnUnset) {
      this.fieldSelected.emit(field);
    }
  }

  updateSelectedField() {
    if (this.selectedField) {
      const { itemKey, formatKey } = this.selectedField;
      const newSelectedField = this.fields.find((field: FormatListItem) => field.itemKey === itemKey);
      if (!newSelectedField) {
        this.selectField();
      } else if (newSelectedField.formatKey !== formatKey) {
        // If itemKey is same, but formatKays are different, then select the new field.
        this.selectField(newSelectedField);
      }
    }
  }

  ngAfterViewInit() {
    if (this.fields.length) {
      // Manually trigger resize event to re-position format menu > context menu
      // Fixes: mispositioning when toggling from QC to VE
      forceResize();

      if (!this.selectedFieldToFormat) {
        this.fieldsMenuTrigger.openMenu();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fields) {
      this.updateSelectedField();
    }

    // Update format options when a user clicks "Format..." from a field's context menu after component has rendered
    if (changes.selectedFieldToFormat?.currentValue && this.selectedFieldToFormat !== null) {
      const formatInfo = this.fields.find((f) => f.formatKey === this.selectedFieldToFormat);
      this.selectField(formatInfo);
      this.updateSelectedField();
    }
  }
}
